import type { TodayTotals } from "../data/replay";

/**
 * Bottom-left key — today's activity broken down by product.
 * Colors match the dots that appear on the map (gold arcs for Send) and
 * the conceptual palette (mint for deposits, violet for conversions).
 */
export function WalletActivity({ totals }: { totals: TodayTotals | null }) {
  const send = totals?.byProduct.send_money ?? { count: 0, volumeUsd: 0 };
  const card = totals?.byProduct.card ?? { count: 0, volumeUsd: 0 };
  const add = totals?.byProduct.add_money ?? { count: 0, volumeUsd: 0 };
  const exch = totals?.byProduct.exchange_money ?? { count: 0, volumeUsd: 0 };

  const rows = [
    { label: "DEPOSITS", color: "var(--product-add)", count: add.count, volume: add.volumeUsd },
    { label: "CONVERSIONS", color: "var(--product-exchange)", count: exch.count, volume: exch.volumeUsd },
    { label: "SEND", color: "var(--product-send)", count: send.count, volume: send.volumeUsd },
    { label: "CARD SPEND", color: "var(--product-card)", count: card.count, volume: card.volumeUsd },
  ];

  return (
    <div className="wallet-activity">
      <div className="wallet-label">TODAY · GMT</div>
      <ul>
        {rows.map((r) => (
          <li key={r.label}>
            <span className="wallet-dot" style={{ background: r.color }} />
            <span className="wallet-row-label">{r.label}</span>
            <span className="wallet-count">{r.count.toLocaleString("en-US")}</span>
            <span className="wallet-vol">${formatAmount(r.volume)}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}

function formatAmount(n: number): string {
  if (n >= 1_000_000) return (n / 1_000_000).toFixed(2) + "M";
  if (n >= 1000) return (n / 1000).toFixed(1) + "K";
  return Math.round(n).toLocaleString("en-US");
}
